import React from 'react'
import {connect} from 'react-redux'

import Notification from './Notification'

import deleteNotification from '../actions/deleteNotification'

const NotificationsContainer = ({notifications, onClose}) => {
  const notificationToComponent = notification => 
    <Notification {...notification} 
                  key={notification.id} 
                  onClose={onClose(notification.id)}/>
                    
  return <div className="notification-container">
    {notifications.map(notificationToComponent)}
  </div>
}

const mapStateToProps = ({notifications}) => ({notifications})

const mapDispatchToProps = dispatch => ({
  onClose: notificationId => _ => dispatch(deleteNotification(notificationId))
})
  
export default connect(mapStateToProps, mapDispatchToProps)(NotificationsContainer)



/** WEBPACK FOOTER **
 ** ./app/components/NotificationsContainer.jsx
 **/